var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.372 33.8943C40.372 36.8062 32.8182 39.1668 23.5002 39.1668C14.1822 39.1668 6.62842 36.8062 6.62842 33.8943C6.62842 30.9825 14.1822 26.5129 23.5002 26.5129C32.8182 26.5129 40.372 30.9825 40.372 33.8943Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1544 22.9978C36.1544 24.9391 30.4891 26.5128 23.5005 26.5128C16.512 26.5128 10.8467 24.9391 10.8467 22.9978C10.8467 21.0566 16.512 18.0769 23.5005 18.0769C30.4891 18.0769 36.1544 21.0566 36.1544 22.9978Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9362 15.4407C31.9362 16.8966 28.1594 18.0769 23.5004 18.0769C18.8413 18.0769 15.0645 16.8966 15.0645 15.4407C15.0645 13.9848 18.8413 11.75 23.5004 11.75C28.1594 11.75 31.9362 13.9848 31.9362 15.4407Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.cc393876bc5871fd3bee150e105da8e9.svg";
export { ForwardRef as ReactComponent };